import { createContext, useReducer } from 'react';

// {
//     isLoggedIn: false,
//     user: {
//         token: null,
//         user_display_name: null,
//         user_email: null,
//         user_nicename: null,
//     },
// }
const storedUser = sessionStorage.getItem('user');
const initialState = {
    isLoggedIn: !!storedUser,
    user: JSON.parse(storedUser),
};

const AuthContext = createContext(initialState);
const AuthDispatchContext = createContext(null);

const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, initialState);

    return (
        <AuthContext.Provider value={state}>
            <AuthDispatchContext.Provider value={dispatch}>
                {children}
            </AuthDispatchContext.Provider>
        </AuthContext.Provider>
    );
};

const authReducer = (state, action) => {
    switch (action.type) {
        case 'login':
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload,
            };
        case 'logout':
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            throw new Error(`Unknown action: ${action.type}`);
    }
};

export { AuthContext, AuthDispatchContext, AuthProvider };